<template>
  <div style="padding-bottom: 60px">
    <header>
      <!--<div style="display: flex">-->
        <!--<div class="search">-->
          <!--<van-search-->
            <!--v-model="name"-->
            <!--shape="round"-->
            <!--background="#6e9bcf"-->
            <!--placeholder="请输入搜索关键词"-->
            <!--v-on:input="getWrite"/>-->
        <!--</div>-->
        <!--<div class="searchIcon">-->
          <!--<van-icon color="#FFFFFF" size="25" name="shopping-cart-o" />-->
        <!--</div>-->
      <!--</div>-->
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">详情</p>
      </div>
    </header>
    <div class="Carousel">
      <div style="width: 100%;height: 150px">
        <van-swipe :autoplay="3000" :duration="100" type="card"  style="width: 90%;height:100%;margin:1rem auto">
          <!--<van-swipe-item v-for="(image, index) in images" :key="index">-->
          <!--<img style="width: 100%;height: 100%" v-lazy="image" />-->
          <!--{{image}}-->
          <!--</van-swipe-item>-->
          <van-swipe-item v-for="(item,index) in list.shop_goods_photo" :key="index">
            <img :src="item.images" style="width: 100%;height: 100%"  />
          </van-swipe-item>
        </van-swipe>
      </div >
    </div>
    <div class="product">
      <p>{{listData.title}}:{{listData.desc}}</p>
      <p class="productPrice" ><span class="firstPrice">￥{{listData.price}}</span><span class="lastPrice">￥{{listData.original_price}}</span></p>
    </div>
    <div class="product">
      <div class="productType">
        <p @click="showPopup"><span class="productx">选择</span><span class="productg">选择规格</span></p>
        <!--<p class="productPrice"><span class="productImg"></span></p>-->
        <p><span class="productImg"></span></p>
      </div>
      <div class="productType">
        <p>
          <span class="productx">发货</span>
          <span class="productg">浙江杭州</span>
          <span style="padding: 0 10px">|</span>
          <span>快递：免邮</span>
        </p>
        <!--<p class="productPrice"><span class="productImg"></span></p>-->
        <p><span class="productImg"></span></p>
      </div>
      <!--<van-popup v-model="show">-->
      <!--dsfdsfsd -->
        <!--内容-->
      <!--</van-popup>-->

      <van-popup v-model="show" closeable position="bottom" :style="{ height: '70%' }" >
        <div>
        <div class="choiceMess">
          <div class="choiceImg">
            <img style="width: 100%;height: 100%" src="https://img.yzcdn.cn/vant/apple-1.jpg" alt="">
          </div>
          <div style="margin-left: 1rem">
            <p>产品名称</p>
            <p v-if="priceList.price">{{priceList.price}}</p>
            <p v-else></p>
          </div>
        </div>
        <div  ref="abc">
          <!--<p>选择{{b}}</p>-->
          <p>
            <!--<span class="choiceType">5g</span>-->

          </p>
          <ul @click="getList" >
            <li v-bind:class="{active:number === index}" v-for="(item,index) in goodsType" @click="change(item,index)">{{item.value_text}}</li>
          {{index}}
          </ul>
        </div>
        <div class="purchaseNum">
          <p>购买数量</p>
          <p><van-stepper v-model="value" /></p>
          <!--<p class="purchaseNum"><span>购买数量</span><span><van-stepper v-model="value" /></span></p>-->
        </div>
        </div>
        <div class="inforName">
          <van-button style="width: 100%;height:2rem;margin: 0 auto" color="red" type="primary" @click="saveCart">确定</van-button>

        </div>
      </van-popup>

      <div class="productType">
        <p><span class="productx">参数</span><span class="productg">尺寸 面料</span></p>
        <!--<p class="productPrice"><span class="productImg"></span></p>-->
        <p><span class="productImg" ></span></p>
      </div>
    </div>

    <div class="product">
      <p>商品详情</p>
      <img style="width: 100%;height: 200px" src="https://img.yzcdn.cn/vant/apple-1.jpg" alt="">
    </div>
    <!--<div class="product">-->
      <!--<p>购买数量</p>-->
      <!--<img style="width: 100%;height: 300px" src="https://img.yzcdn.cn/vant/apple-1.jpg" alt="">-->
    <!--</div>-->
<!--<footer>-->
  <!--<div class="shopCart">-->

    <!--<van-icon size="25" name="shopping-cart-o" />-->
  <!--</div>-->
  <!--<div class="footerDiv" style="background: #ffae4d">加入购物车</div>-->
  <!--<div class="footerDiv" style="background: #c61414">立即购买</div>-->
<!--</footer>-->
    <van-goods-action>
      <van-goods-action-icon icon="chat-o" text="客服" color="#ee0a24" />
      <van-goods-action-icon icon="cart-o" text="购物车" @click="toShopCart"/>
      <!--<van-goods-action-icon icon="star" text="已收藏" color="#ff5000" />-->
      <van-goods-action-button type="warning " @click="addCart" text="加入购物车" />
      <van-goods-action-button type="danger" @click="purchase" text="立即购买" />
    </van-goods-action>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Swipe, SwipeItem } from 'vant';

  Vue.use(Swipe);
  Vue.use(SwipeItem);
  //  import Vue from 'vue';
  import { Lazyload } from 'vant'
  Vue.use(Lazyload);
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
        radio:'',
        list: [
          'https://img.yzcdn.cn/vant/apple-1.jpg',
          'https://img.yzcdn.cn/vant/apple-2.jpg',
          'https://img.yzcdn.cn/vant/apple-3.jpg',
        ],
        listData:[],
        arrType:["5g","10g","15g","20g"],
        goodsType:[],
        show:false,
        number:0,
        value:1,
        activeClass: 'active',
        itemList:{},
        priceList:{}
      }
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      toShopCart(){
        this.$router.push("/newShop")
      },
      showPopup() {
        this.show = true;
      },
      addCart(){
        this.show = true;
      },
      purchase(){
        this.show = true;
      },
      saveCart(){
        console.log(this.value)
        this.$toast("成功添加购物车")
        this.$api.insertCarts({
          id:this.$route.query.id,
          "data[user_id]":localStorage.getItem("userid"),
          "data[goods_id]":this.itemList.goods_id,
          "data[goods_spec_id]":this.itemList.goods_spec_id,
          "data[title]":this.list.title,
          "data[img]":this.list.img,
          "data[price]":this.itemList.price,
          "data[original_price]":this.itemList.original_price,
          "data[stock]":this.value,
        })
          .then(res=>{

          })
        this.show = false;
      },
      getList(event){
      },
      change(item,index){
        this.itemList=item
        let _this=this
        this.list.all_spec_item.goods_spec.forEach(function (a,b) {
          if(a.id==item.goods_spec_id){
            _this.priceList=a
            _this.itemList.price=a.price
            _this.itemList.original_price=a.original_price
          }
        })
        this.number=index
      },
      GoodsDetailer(){
        this.$api.GoodsDetail({
          id:this.$route.query.id
        })
          .then(res=>{
            this.listData=res.data[0]
            this.list=res.data[0]
            var item=this.list.all_spec_item
//            for(var i in item){
//              item[i]
//              console.log(item[i].goods_id)
//              item.forEach(res=>{
//                console.log(res)
//              })
//            }
            this.goodsType=res.data[0].all_spec_item.goods_spec_type
            for(var i in this.goodsType){
              this.number=this.goodsType[i].goods_spec_id
            }
          })
      },
    },
    mounted(){
      this.GoodsDetailer()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  header{
    width: 100%;
    height: 60px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 70px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 18px;
  }
  .Carousel{
    margin-top: 70px;
  }
  .product{
    border-bottom: solid 5px #E4E4E4;
    padding:0 1rem;
  }
  .product p{
    padding-top: 5px;
  }
  .productPrice{
    margin-top: 10px;
    /*padding-left: 1rem;*/
  }
  .lastPrice{
    margin-left: 1rem;
    text-decoration: line-through;
  }
  .firstPrice{
    font-size: 22px;
    color: #c61414;
  }
  .productx{
    color: #c9c9c9;
  }
  .productg{
    margin-left: 1rem;
  }
  .productImg{
    background-image: url(../../assets/img/gonext.png);
    background-repeat: no-repeat;
    background-position: 98% center;
    background-size: 7px 15px;
    padding-right: 1rem;
  }
  .productType{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
  }
  footer{
    z-index: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: content-box;
    width: 100%;
    /*height: 50px;*/
    background-color: #fff;
    position: fixed;
    bottom: 0;
  }
  .shopCart{
    flex: 1;
    text-align: center;
    padding: 1rem 0;
  }
  .footerDiv{
    width: 30%;
    text-align: center;
    padding: 1rem 0px;
    color: #ffffff;
  }
  .choiceImg{
    width: 80px;
    height: 80px;
  }
  .choiceMess{
    display: flex;
    align-items: center;
  }
  .choiceType{
    width: 80px;

  }
  ul{
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  ul li {
    border: solid 1px #e2e2e2;
    padding: 3px 5px;
    margin-right: 10px;
    margin-top: 10px;
    border-radius: 4px;
    font-size: 13px;
  }
  .active{  color:red;  }
  .purchaseNum{
    display: flex;
    justify-content: space-between;
    padding: 1rem;
  }
  .inforName{
    position: fixed;
    bottom: 0;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/shop/shopDetail.vue